import React, { Component } from 'react';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';

import { Chatroom, leaveRoom } from 'nm-react-chat';

import WavyLayout from './../../hoc/WavyLayout/WavyLayout';

import Zigzag from './../../containers/UI/Common/Shapes/Zigzag';

//-- Utils
import { pushHeaderTitle } from '../../utils/dom/helper';
import { pushPageView } from '../../utils/tracking/customGtm';

export class Chat extends Component {

    componentDidMount() {
        //-- Update title
        pushHeaderTitle('Pose tes questions à nos journalistes');

        //-- Push GTM page view
        pushPageView();
    }

    handleClick = () => {
        const { dispatch } = this.props;
        dispatch(leaveRoom());
        dispatch(goBack());
    }

    render(){
        const { chatroomId } = this.props;
        let chatroom = '';

        if(chatroomId !== '')
        {
            chatroom = (<Chatroom />);
        }

        return(
            <WavyLayout
                page="chat"
                title="Pose tes questions à nos journalistes"
                handleClick={this.handleClick}
                color="#fd8598">
                <div className="green-shape">    
                    <Zigzag color="#30e6ca" />
                </div>
                <div className="yellow-shape">    
                    <Zigzag color="#ffde39" />
                </div>
                {chatroom}  
            </WavyLayout>
        );
    }
}

const mapStateToProps = state => {
    return {
        chatroomId: state.chatroom.chatroomId
    }
};

export default connect( mapStateToProps )(Chat);




// WEBPACK FOOTER //
// ./src/containers/Chat/Chat.js